<div class="wrapper">
  <ng-container [formGroup]="parentForm">
    <ui-form-field
      label="رمز دوم"
      [autoFocus]="autofocus"
      [formControlName]="controlName"
      [maxSize]="12"
      (click)="onFocusIn($event)"
      [inputType]="'password'"
      [autoComplete]="'one-time-code'"
      [isNumericKeyboard]="true"
      [convertNonEnglishDigits]="true"
    ></ui-form-field>
  </ng-container>

  <div class="action-wrapper">
    <div
      class="action send-dynamic-pass"
      *ngIf="countdownSeconds === null && !inProgress"
      [ngClass]="{ disabled: !enableSendButton }"
      (click)="onSend()"
    >
      <span class="icon">
        <common-icon-dp-icon
          [icon]="'lock'"
          [iconSize]="'24'"
          [iconType]="'linear'"
          [classes]="enableSendButton ? 'text-onback-brand' : 'text-onback-disabled'"
        ></common-icon-dp-icon>
      </span>
      درخواست رمز پویا
    </div>

    <div
      class="action in-progress"
      *ngIf="inProgress"
    >
      <common-ui-loading-dots [color]="'#1159FC'"></common-ui-loading-dots>
    </div>

    <div
      class="action countdown"
      *ngIf="countdownSeconds !== null"
    >
      <span class="icon">
        <common-icon-dp-icon
          [icon]="'circle-clock'"
          [iconType]="'linear'"
          [iconSize]="'24'"
        ></common-icon-dp-icon>
      </span>
      <div class="countdown-text">
        <ng-container *ngIf="showParentheses">(</ng-container>{{ formattedTime.minutes }}:{{ formattedTime.seconds
        }}<ng-container *ngIf="showParentheses">)</ng-container>
      </div>
    </div>
  </div>
</div>
